import { render, staticRenderFns } from "./view-application-education.vue?vue&type=template&id=44b15f48&"
import script from "./view-application-education.vue?vue&type=script&lang=js&"
export * from "./view-application-education.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports